import ScriptMediator from './ScriptMediator';

export default ScriptMediator;
